import { v4 as uuid } from 'uuid';
import { EntityBuilder } from '@decahedron/entity';
import { Question } from 'packages/form/entities/legacy/question/Question';
import { MultiChoiceQuestion } from 'packages/form/entities/legacy/question/MultiChoiceQuestion';
var QuestionBuilder = /** @class */ (function () {
    function QuestionBuilder() {
    }
    QuestionBuilder.fromBlockPrototype = function (selectedBlock) {
        var question = (selectedBlock.preset.type === 'select')
            ? EntityBuilder.buildOne(MultiChoiceQuestion, selectedBlock.preset)
            : EntityBuilder.buildOne(Question, selectedBlock.preset);
        question.uuid = uuid();
        return question;
    };
    return QuestionBuilder;
}());
export { QuestionBuilder };
